import React, { useState,useEffect } from 'react';
import './pcb_designing.css';

const PCBDesign = () => {
  const[config,setConfig]=useState(null);
   const [message, setMessage] = useState(null);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    organization: '',
    query: '',
    file: null
  });

   useEffect(() => {
      fetch("/config.json")
        .then(res => res.json())
        .then(data => setConfig(data))
        .catch(err => console.error("Failed to load config.json", err));
    }, []);

      useEffect(() => {
        if (message) {
          const timer = setTimeout(() => setMessage(null), 5000);
          return () => clearTimeout(timer);
        }
      }, [message]);

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: files ? files[0] : value
    }));
  };

const handleSubmit = async (e) => {
    e.preventDefault();
    if (!config) {
      return;
    }

    if (!formData.file) {
      setMessage("Please upload a Gerber file");
      return;
    }  

    const data = new FormData();
    data.append("name", formData.name);
    data.append("mail", formData.email);
    data.append("company", formData.organization);
    data.append("query", formData.query);
    data.append("gerber_file", formData.file);

    try {
      const res = await fetch(
        `${config.BASE_URL}${config.PCB_DESIGN_SUBMIT}`,
        {
          method: "POST",
          body: data,
          credentials: "include"
        }
      );

      const result = await res.json();
      if (result.success) {
        setMessage("Form submitted successfully!");
        setFormData({
          name: "",
          email: "",
          organization: "",
          query: "",
          file: null
        });
      } else {
        setMessage(result.message || "Submission failed");
      }
    } catch (err) {
      console.error("Error:", err);
      setMessage("Error submitting form");
    }
  };


  return (
    <div className="pcb-page">
      {/* Hero Section with Image */}
      <div className="pcb-hero">
        <img 
          src='/pcb-image.webp' 
          alt='PCB Design Background' 
          className="pcb-hero-image"
        />
        <div className="pcb-hero-overlay"></div>
        <div className="pcb-hero-content">
          <h1>PCB Design Services</h1>
          <p>Professional printed circuit board design for your projects</p>
         <div className="pcb-hero-steps">
          <span>Idea</span>
          <span>➡️</span>
          <span> Upload Gerber File</span>
          <span>➡️</span>
          <span> Get Your Pcb</span>
        </div>

        </div>
      </div>

      {/* Main Content Section */}
      <div className="pcb-content">
        <div className="pcb-section">
          <h2>Our PCB Design Process</h2>
          <div className="pcb-features">
            <div className="pcb-feature">
              <div className="pcb-icon">1</div>
              <h3>Schematic Design</h3>
              <p>We create detailed circuit schematics to ensure proper functionality.</p>
            </div>
            <div className="pcb-feature">
              <div className="pcb-icon">2</div>
              <h3>Routing & Layout</h3>
              <p>Precision routing for signal integrity and EMI reduction.</p>
            </div>
            <div className="pcb-feature">
              <div className="pcb-icon">3</div>
              <h3>Component Placement</h3>
              <p>Optimal component positioning for performance and manufacturability.</p>
            </div>
          </div>
        </div>

        <div className="pcb-section pcb-dark">
          <h2>Our Capabilities</h2>
          <ul className="pcb-capabilities">
            <li>Multi-layer PCB designs (up to 16 layers)</li>
            <li>High-speed digital and RF designs</li>
            <li>Flex and rigid-flex PCB solutions</li>
            <li>DFM/DFA optimization</li>
            <li>Prototyping support</li>
          </ul>
        </div>

 <div className="pcb-section">
  <h2>Get Started</h2>
  <p className='form-paragraph'>Ready to begin your PCB design project? Upload your Gerber file.</p>
  
  <div className="form-image-split">
    {/* Form Column */}
    <div className="form-column">
      <form className="pcb-contact-form" onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="name">Full Name</label>
          <input
            type="text"
            id="name"
            name="name"
            placeholder="Enter your name"
            value={formData.name}
            onChange={handleChange}
            required
          />
        </div>
        
        <div className="form-group">
          <label htmlFor="email">Email</label>
          <input
            type="email"
            id="email"
            name="email"
            placeholder="your@email.com"
            value={formData.email}
            onChange={handleChange}
            required
          />
        </div>
        
        <div className="form-group">
          <label htmlFor="organization">University/Company</label>
          <input
            type="text"
            id="organization"
            name="organization"
            placeholder="Your institution or company"
            value={formData.organization}
            onChange={handleChange}
            required
          />
        </div>
        
        <div className="form-group">
          <label htmlFor="query">Your Query</label>
          <textarea
            id="query"
            name="query"
            placeholder="Describe your PCB design requirements..."
            value={formData.query}
            onChange={handleChange}
            required
          />
        </div>
        
        <div className="form-group">
          <label>Upload Gerber File</label>
          <div className="file-upload-wrapper">
            <input
              type="file"
              id="file"
              name="file"
              onChange={handleChange}
              accept=".gbr,.zip,.ger"
              required
            />
            <div className="file-upload-name">
              {formData.file ? formData.file.name : 'No file chosen'}
            </div>
          </div>
        </div>
        
        <button type="submit" className="pcb-form-submit">
          Submit Request
        </button>
      </form>
    </div>
    
    {/* Image Column */}
    <div className="pcb-image-column">
      <img 
        src="/pcb-robot.jpg" 
        alt="PCB Design Sample" 
        className="form-side-image"
      />
      <div className="image-caption">
        <h3>Professional PCB Design</h3>
        <p>We create optimized layouts for maximum performance</p>
      </div>
    </div>
  </div>
</div>
      </div>
       {message && (
        <div
          style={{
            position: "fixed",
            top: "50px",
            left: "50%",
            transform: "translateX(-50%)",
            padding: "15px 20px",
            borderRadius: "12px",
            background: "rgba(255,255,255,0.15)",
            backdropFilter: "blur(10px)",
            WebkitBackdropFilter: "blur(10px)",
            boxShadow: "0 4px 20px rgba(0,0,0,0.2)",
            color: "black",
            fontSize: "14px",
            fontWeight: "500",
            zIndex: 1000,
            minWidth: "250px",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center"
          }}
        >
          <span>{message}</span>
          <span
            style={{ marginLeft: "15px", cursor: "pointer" }}
            onClick={() => setMessage(null)}
          >
            ×
          </span>
        </div>
      )}
    </div>
  );
};

export default PCBDesign;